// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1wUl6","info":"Note_info__HkJTT","note":"Note_note__3yBpW","actions":"Note_actions__2mf-6"};